import { Component, inject, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DisbursmentService } from 'src/app/shared/service/disbursment/disbursment.service';
import { allowOnlyLetters, allowLimitedInput, trimInput, handlePasteText } from '../../master.utils';
import { ToastrService } from 'ngx-toastr';
import { PurposeService } from 'src/app/shared/service/disbursment/purpose.service';

@Component({
  selector: 'app-create-purpose',
  templateUrl: './create-purpose.component.html',
  styleUrls: ['./create-purpose.component.scss']
})
export class CreatePurposeComponent {
 private loader = inject(DisbursmentService);
 isLoading$ = this.loader.loading$;
  disallowNumericData = allowOnlyLetters;
  allowLimitedInput = allowLimitedInput;
  purposeForm: FormGroup;
  isEditMode = false;
  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<CreatePurposeComponent>,
    @Inject(MAT_DIALOG_DATA) public existingdata: any,
    private purposeService: PurposeService,
    private snackBar: ToastrService
  ) {
    const data = existingdata?.rowData;
    this.isEditMode = !!data;
    this.purposeForm = this.fb.group({
      purpose_id: [data?.purpose_id || 0],
      name: [data?.name || '', Validators.required],
    });
  }

  //method to trim the input
  onInputTrim(controlName: string): void {
    const control = this.purposeForm.get(controlName);
    trimInput(control);
  }


  onPaste(event: ClipboardEvent): void {
    const value = handlePasteText(event);
    this.purposeForm.get('name')?.setValue(value);
  }



  // onSubmit method will trigger when the Add or Edit Purpose button clicks
  onSubmit() {
    if (this.purposeForm.valid) {
      this.loader.showDialogLoader();
      this.purposeService.purposeDataToDb(this.purposeForm.value).subscribe({
        next: (res: any) => {
          this.loader.hideDialogLoader();
          this.snackBar.success(res.message);
          this.dialogRef.close("refresh");
        },
        error: (error: any) => {
          this.loader.hideDialogLoader();
          const errorMsg = error.error?.error || 'Something went wrong. Please try again.';
          this.snackBar.error(errorMsg);
        }
      })
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
